@if (currentSelectedTopic()) {
    @if (currentTopicSelectedStory()) {
        <st-story-full-screen
            standaloneStory
            [data]="currentTopicSelectedStory()"
            [disabled]="currentSelectedTopic()?.Path.isWasteBinPath"
            [sidecarMenu]="sidecarMenu()" />
    } @else if (currentTopicSelectedAssignment()) {
        <st-assignment-full-screen
            [data]="currentTopicSelectedAssignment()"
            [disabled]="currentTopicSelectedAssignment()?.topicMetadata?.Path?.isWasteBinPath"
            [parentTopicMosActive]="currentSelectedTopic()?.MOSControl"
            [sidecarMenu]="sidecarMenu()" />
    } @else {
        <st-topic-full-screen
            [data]="currentSelectedTopic()"
            [sidecarMenu]="sidecarMenu()"
            (assignmentOpen)="onAssignmentOpenHandler($event)"
            (storyOpen)="onStoryOpenHandler($event)" />
    }
    @if (currentTopicSelectedStory() || currentTopicSelectedAssignment()) {
        <div class="st-topic-list-sidecar-pager">
            <button
                mat-icon-button
                class="st-topic-list-sidecar-pager-button-first"
                (click)="navigate(NavigationDirection.FIRST, currentTopicSelectedStory() ? ObjectTypesEnum.SCRIPT : ObjectTypesEnum.ASSIGNMENT)">
                <mat-icon>first_page</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-topic-list-sidecar-pager-button-previous"
                (click)="navigate(NavigationDirection.PREVIOUS, currentTopicSelectedStory() ? ObjectTypesEnum.SCRIPT : ObjectTypesEnum.ASSIGNMENT)">
                <mat-icon>navigate_before</mat-icon>
            </button>
            <span class="st-topic-list-sidecar-pager-text">{{ currentTopicSelectedStory() ? 'Story' : 'Assignment' }} {{ indexInParentToShow() }} of {{ totalCount() }}</span>
            <button
                mat-icon-button
                class="st-topic-list-sidecar-pager-button-next"
                (click)="navigate(NavigationDirection.NEXT, currentTopicSelectedStory() ? ObjectTypesEnum.SCRIPT : ObjectTypesEnum.ASSIGNMENT)">
                <mat-icon>navigate_next</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-topic-list-sidecar-pager-button-last"
                (click)="navigate(NavigationDirection.LAST, currentTopicSelectedStory() ? ObjectTypesEnum.SCRIPT : ObjectTypesEnum.ASSIGNMENT)">
                <mat-icon>last_page</mat-icon>
            </button>
        </div>
    }
} @else {
    <div class="st-topic-list-sidecar-label">{{ topicsLabel$ | ngrxPush }}</div>
    <div class="st-topic-list-sidecar__grid">
        <mat-button-toggle-group
            class="st-topic-list-sidecar-buttons-group"
            [value]="selectedListSearchType()"
            (change)="toggleSearchTab($event)">
            <mat-button-toggle
                class="st-topic-list-sidecar-buttons-group__search"
                [value]="SearchType.SEARCH">
                {{ languageSettings.PSTWebCastSearchTabLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-topic-list-sidecar-buttons-group__views"
                [value]="SearchType.SAVED">
                {{ languageSettings.PSTWebSavedViewsTabLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="st-topic-list-sidecar__grid__right">
            @if (savedViewDropdownVisible()) {
                <mat-form-field
                    class="st-topic-list-sidecar__views-dropdown"
                    subscriptSizing="dynamic">
                    <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>
                    <mat-select
                        [value]="currentViewState()?.Guid"
                        [placeholder]="languageSettings.PSTWebSavedViewsLabel"
                        (selectionChange)="onViewStateGuidChanged($event)">
                        @for (item of selectSavedViewStates(); track item.Guid) {
                            <mat-option [value]="item.Guid">
                                {{ item.Title }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <div class="st-topic-list-sidecar__search-bar">
                    <!-- <st-simple-search-box
                        st-click-stop-propagation
                        class="st-topic-list-sidecar__search-bar__search"
                        (searchThermChange)="onSearchHandler($event)" /> -->
                    <st-simple-search-box-autocomplete
                        st-click-stop-propagation
                        class="st-cast-objects-list__search-bar__search"
                        (searchExecute)="onSearchHandler($event)" />
                </div>
            }
        </div>
    </div>

    @if (selectTopics()?.length === 0) {
        <div class="st-topic-list-sidecar-text">
            {{ 'Sorry, there are no results matching your criteria' }}
        </div>
    } @else {
        <cdk-virtual-scroll-viewport
            maxBufferPx="0"
            minBufferPx="0"
            class="st-topic-list-sidecar-viewport"
            [itemSize]="itemSize()">
            <div
                *cdkVirtualFor="let record of selectTopics(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                class="st-topic-list-sidecar-viewport-topic-item">
                <st-topic-item
                    class="st-topic-list-sidecar-viewport-topic-item-type"
                    [data]="record"
                    [cardViewType]="cardViewType()"
                    [attr.small]="cardViewType() === CardViewType.SMALL"
                    [inSidecarOpenedMode]="isSideCarMenuSelected()"
                    (topicItemClicked)="onFullscreenHandler(record)"
                    (assignmentItemClicked)="onAssignmentFromCardHandler(record, $event)" />
            </div>
        </cdk-virtual-scroll-viewport>
    }
}
